
export class BaseValueAccessor<T>  {
  private innerValue: T;
  private isInterventionEnabled: boolean = false;

  constructor() {
  }

  // get accessor
  get value(): T {
    return this.innerValue;
  }

  // set accessor including call the onchange callback
  set value(v: T) {
    if (v !== this.innerValue) {
      this.innerValue = v;
      this.onChangeCallback(v);
    }
  }

  enableIntervention(): void {
    this.isInterventionEnabled = true;
  }

  // From ControlValueAccessor interface
  writeValue(value: T): void {
    if (value !== this.innerValue) {
      this.innerValue = value;
      // warning: comment below if only want to emit on user intervention
      if (this.isInterventionEnabled) {
        this.onChangeCallback(value);
      }
    }
  }

  // From ControlValueAccessor interface
  registerOnChange(fn: () => unknown): void {
    this.onChangeCallback = fn;
  }

  // From ControlValueAccessor interface
  registerOnTouched(): void {
  //   this.onTouchedCallback = fn;
  }

  //
  // private onTouchedCallback: () => void =  (): void => {};
  private onChangeCallback: (_: unknown) => void =  (): void => {};
}
